export enum Color {
  red = 'hsl(346,100%,43%)',
  grey = 'hsla(0,0%,0%,0.5)',
  white = '#fff',
}
